import React from "react";
import { getTranslation as translate } from "logic/LocaleManager";

export default function ErrorMessageView(props) {
  const { error } = props;
  const errorMessage = error || translate("general.dataError", "Trouble getting data :-(");

  const wrapperStyle = {
    display: "inline-block",
    margin: "0.5em",
    padding: "1em",
    border: "1px dotted red",
    cursor: "default"
  };

  const contentStyle = {
    fontWeight: "bold",
    color: "red"
  }

  return (
    <div style={wrapperStyle}>
      <div style={contentStyle}>
        {errorMessage}
      </div>
    </div>
  );
}